<template>
  <div id="seletor">
    <h1 class="seletor-line"></h1>
        <el-checkbox-group v-model="selectedMutable" @change="update">
          <el-checkbox v-for="(element, index) in elements" :label="element" :key="element.id">
            <template slot-scope>
              <span class="seletor-label-only">{{element.name}}</span> <span v-if="element.color" :style="statusColor(element.color)" class="status"></span>
            </template>
            <h1 v-if="index != Object.keys(elements).length - 1" class="seletor-checkbox-line"></h1>
          </el-checkbox>
        </el-checkbox-group>
  </div>
</template>
<script>
export default {
  props: {
    model: {
      type: Array
    },
    elements: {
      type: Array
    },
    name: {
      type: String
    },
    selected: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    selected (newValue) {
      this.selectedMutable = newValue
    }
  },
  data () {
    return {
      selectedMutable: []
    }
  },
  created () {
    this.selectedMutable = this.selected
  },
  methods: {
    update () {
      this.$emit('update:selected', this.selectedMutable)
    },
    statusColor (color) {
      return {
        'background-color': `${color} !important`
      }
    }
  }
}
</script>
